const collectionContainers = document.querySelectorAll('.collection[data-url-trigger]');

collectionContainers.forEach(container => {
    const url = container.getAttribute('data-url-trigger');
    const trigger = document.querySelector(`a.mega-menu-trigger[href="${url}"]`);

    //We add the event listeners to all triggers

    trigger.addEventListener('mouseover', () => {
        showCollectionContainer(container)
    });
});

//Main nav links also need to trigger the collection container
const mainNavLinks = document.querySelectorAll('.site-nav__link.first-level');

mainNavLinks.forEach(link => {

    link.addEventListener('mouseover', () => {
        const dropdown = link.nextElementSibling;

        if (dropdown) {
            let dropdownTriggers = dropdown.querySelectorAll('.mega-menu-trigger');

            //We find the first triggers that includes /collections/ in the href
            let trigger = Array.from(dropdownTriggers).find(trigger => trigger.href.includes('/collections/'));
            let url = trigger.getAttribute('href');
            
            let container = document.querySelector(`.collection[data-url-trigger="${url}"]`);

            showCollectionContainer(container);
        }
    });
})

function showCollectionContainer(container) {

    //Hide all collection containers
    collectionContainers.forEach(container => {
        if (!container.classList.contains('no-show')) {
            container.classList.add('no-show');
        }
    });

    //Show the proper container
    container.classList.remove('no-show');

}
